import { render, staticRenderFns } from "./partinstall.vue?vue&type=template&id=63b63877&scoped=true&"
import script from "./partinstall.vue?vue&type=script&lang=js&"
export * from "./partinstall.vue?vue&type=script&lang=js&"
import style0 from "./partinstall.vue?vue&type=style&index=0&id=63b63877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b63877",
  null
  
)

export default component.exports